import React, { ReactNode } from 'react';

import classNames from 'classnames';

import Paragraph from '@/components/Elements/Paragraph/Paragraph';
import {
  HeaderInfoComponent,
  HeaderInfoType,
} from '@/components/Layouts/ResizeLayout/HeaderInfoComponent/HeaderInfoComponent';

import useResizeLayout from '@/hooks/useResizeLayout';
import { useRouteChangedGTMEvent } from '@/hooks/useRouteChangedGTMEvent';

import { IDescription, ILandingRelatedMenu } from '@/types/types';

import ContactUs from '../../Sections/ContactUs/ContactUs';
import Footer from '../../Sections/Footer/Footer';
import IntroSection from '../../Sections/IntroSection/IntroSection';
import Menu from '../../Sections/Menu/Menu';
import Section from '../../Sections/Section';

import './ResizeLayout.scss';

interface Props {
  children: ReactNode;
  title: string;
  description?: IDescription;
  customClass: string;
  activeMenuItem?: ILandingRelatedMenu;
  menuBackground?: boolean;
  headerInfo?: HeaderInfoType;
}

const ResizeLayout = ({
  children,
  title,
  description,
  customClass,
  activeMenuItem,
  menuBackground,
  headerInfo,
}: Props) => {
  const { headerRef, mainRef, mainWidth } = useResizeLayout();

  useRouteChangedGTMEvent();

  return (
    <div className={classNames('ResizeLayout_container', customClass)}>
      <Menu backgroundColor={menuBackground ? undefined : 'dark'} activeMenuItem={activeMenuItem} />
      <IntroSection
        customClass={classNames('ResizeLayout_intro-section', customClass)}
        leftContent={headerInfo && <HeaderInfoComponent headerInfo={headerInfo} />}
        rightContent={
          <>
            <h1>{title}</h1>
            {description && (
              <Paragraph item={description} paragraphClass="body-2 ResizeLayout_intro-section-description" />
            )}
            {headerInfo && <HeaderInfoComponent headerInfo={headerInfo} />}
          </>
        }
        ref={headerRef}
      />
      <section ref={mainRef} style={{ width: mainWidth }} className="ResizeLayout_main-section">
        <main>{children}</main>
        <ContactUs />
        <footer className="ResizeLayout_footer">
          <Section backgroundColor="dark">
            <Footer />
          </Section>
        </footer>
      </section>
    </div>
  );
};

export default ResizeLayout;
